import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BackgroundColorIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "BackgroundColor",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M27.27 13.83 16.48 3.05c-.3-.29-.72-.48-1.17-.48s-.87.18-1.17.48L3.44 13.7C2.55 14.59 2 15.82 2 17.18s.55 2.59 1.44 3.48l6.22 6.21c.89.89 2.12 1.44 3.48 1.44s2.59-.55 3.48-1.44l10.66-10.66c.3-.3.49-.72.49-1.19s-.19-.88-.49-1.19ZM15.3 6.6l8.26 8.26H7.02l8.27-8.26Zm11.35 12.75-2.24 5.6v3.36h1.12v1.12h3.36v-1.12h1.12v-3.36l-2.24-5.6z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M28 26.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5 1.5-3.5 1.5-3.5 1.5 2.67 1.5 3.5"
      }), /*#__PURE__*/_jsx("path", {
        d: "M26.5 29a2.5 2.5 0 0 1-2.5-2.5c0-.95 1.02-2.91 1.63-3.99.35-.63 1.39-.63 1.74 0 .61 1.08 1.63 3.04 1.63 3.99a2.5 2.5 0 0 1-2.5 2.5m0-3.8c-.29.62-.48 1.13-.5 1.32 0 .26.22.49.5.49s.5-.22.5-.49c-.02-.2-.21-.7-.5-1.32M9 17h9.08l-4.54 4.54z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.54 22.55c-.27 0-.52-.11-.71-.29l-4.54-4.54c-.29-.29-.37-.72-.22-1.09s.52-.62.92-.62h9.08a1.002 1.002 0 0 1 .7 1.71l-4.54 4.54a1 1 0 0 1-.71.29ZM11.41 18l2.13 2.13L15.67 18h-4.25Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.52 27.1c-.77 0-1.54-.29-2.12-.88L3.88 18.7c-.57-.57-.88-1.32-.88-2.12s.31-1.55.88-2.12l6.29-6.29a.996.996 0 1 1 1.41 1.41l-6.29 6.29c-.19.19-.29.44-.29.71s.1.52.29.71l7.52 7.52c.38.38 1.04.38 1.41 0l7.25-7.25a1 1 0 0 1 .71-.29h1.5L11.13 4.71a.996.996 0 1 1 1.41-1.41L26.8 17.56c.29.29.37.72.22 1.09s-.52.62-.92.62h-3.5l-6.96 6.96a3 3 0 0 1-2.12.88Z"
      })]
    })
  }));
};